import { CurrencyState } from 'app/currencies/store/CurrencyState';
import {
    CurrencyAction,
    CurrencyActionType,
} from 'app/currencies/store/actions';
import keyby from 'lodash/keyBy';
import { Reducer } from 'redux';

export const initialCurrencyState = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    USD: { symbol: 'USD', prefix: '$', rate: 1 },
};

export const currenciesReducer: Reducer<CurrencyState, CurrencyAction> = (
    state = initialCurrencyState,
    action
) => {
    switch (action.type) {
        case CurrencyActionType.SET_CURRENCIES: {
            return {
                ...state,
                ...keyby(action.payload!.currencies, 'symbol'),
            };
        }
    }
    return state;
};
